/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Features_Analyzetrends1Inputs */

const id_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisis tren dan pola di Epic Games Store`)
};

const ms_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisis trend dan corak di Epic Games Store`)
};

const da_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyser trends og mønstre i Epic Games Store`)
};

const de_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysieren Sie Trends und Muster im Epic Games Store`)
};

const en_us2_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze trends and patterns in the Epic Games Store`)
};

const es_es2_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analiza tendencias y patrones en la Epic Games Store`)
};

const es_mx2_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analiza tendencias y patrones en la Epic Games Store`)
};

const fil_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suriin ang mga trend at pattern sa Epic Games Store`)
};

const fr_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyser les tendances et schémas de l'Epic Games Store`)
};

const it_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizza tendenze e modelli nell'Epic Games Store`)
};

const hu_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trendek és minták elemzése az Epic Games Store-ban`)
};

const nl_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyseer trends en patronen in de Epic Games Store`)
};

const no_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyser trender og mønstre i Epic Games Store`)
};

const pl_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizuj trendy i wzorce w Epic Games Store`)
};

const pt_br2_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analise tendências e padrões no Epic Games Store`)
};

const pt_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analise tendências e padrões na Epic Games Store`)
};

const ro_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizează tendințele și modelele din Epic Games Store`)
};

const fi_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysoi trendejä ja kaavoja Epic Games Storessa`)
};

const sv_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysera trender och mönster i Epic Games Store`)
};

const vi_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phân tích xu hướng và mô hình trong Epic Games Store`)
};

const tr_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store'daki trendleri ve kalıpları analiz edin`)
};

const cs_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyzujte trendy a vzory v Epic Games Store`)
};

const bg_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Анализирайте тенденции и модели в Epic Games Store`)
};

const ru_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Анализируйте тенденции и закономерности в Epic Games Store`)
};

const uk_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аналізуйте тенденції та закономірності в Epic Games Store`)
};

const ar_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحليل الاتجاهات والأنماط في Epic Games Store`)
};

const hi_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store में रुझानों और पैटर्न का विश्लेषण करें`)
};

const th_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วิเคราะห์แนวโน้มและรูปแบบใน Epic Games Store`)
};

const ja_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store のトレンドとパターンを分析`)
};

const zh_cn2_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分析Epic游戏商城的发展趋势和模式`)
};

const zh_hant1_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分析Epic遊戲商城的發展趨勢和模式`)
};

const ko_about_features_analyzetrends1 = /** @type {(inputs: About_Features_Analyzetrends1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store의 트렌드 및 패턴 분석`)
};

/**
* | output |
* | --- |
* | "Analyze trends and patterns in the Epic Games Store" |
*
* @param {About_Features_Analyzetrends1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const about_features_analyzetrends1 = /** @type {((inputs?: About_Features_Analyzetrends1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Features_Analyzetrends1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_about_features_analyzetrends1(inputs)
	if (locale === "ms") return ms_about_features_analyzetrends1(inputs)
	if (locale === "da") return da_about_features_analyzetrends1(inputs)
	if (locale === "de") return de_about_features_analyzetrends1(inputs)
	if (locale === "en-US") return en_us2_about_features_analyzetrends1(inputs)
	if (locale === "es-ES") return es_es2_about_features_analyzetrends1(inputs)
	if (locale === "es-MX") return es_mx2_about_features_analyzetrends1(inputs)
	if (locale === "fil") return fil_about_features_analyzetrends1(inputs)
	if (locale === "fr") return fr_about_features_analyzetrends1(inputs)
	if (locale === "it") return it_about_features_analyzetrends1(inputs)
	if (locale === "hu") return hu_about_features_analyzetrends1(inputs)
	if (locale === "nl") return nl_about_features_analyzetrends1(inputs)
	if (locale === "no") return no_about_features_analyzetrends1(inputs)
	if (locale === "pl") return pl_about_features_analyzetrends1(inputs)
	if (locale === "pt-BR") return pt_br2_about_features_analyzetrends1(inputs)
	if (locale === "pt") return pt_about_features_analyzetrends1(inputs)
	if (locale === "ro") return ro_about_features_analyzetrends1(inputs)
	if (locale === "fi") return fi_about_features_analyzetrends1(inputs)
	if (locale === "sv") return sv_about_features_analyzetrends1(inputs)
	if (locale === "vi") return vi_about_features_analyzetrends1(inputs)
	if (locale === "tr") return tr_about_features_analyzetrends1(inputs)
	if (locale === "cs") return cs_about_features_analyzetrends1(inputs)
	if (locale === "bg") return bg_about_features_analyzetrends1(inputs)
	if (locale === "ru") return ru_about_features_analyzetrends1(inputs)
	if (locale === "uk") return uk_about_features_analyzetrends1(inputs)
	if (locale === "ar") return ar_about_features_analyzetrends1(inputs)
	if (locale === "hi") return hi_about_features_analyzetrends1(inputs)
	if (locale === "th") return th_about_features_analyzetrends1(inputs)
	if (locale === "ja") return ja_about_features_analyzetrends1(inputs)
	if (locale === "zh-CN") return zh_cn2_about_features_analyzetrends1(inputs)
	if (locale === "zh-Hant") return zh_hant1_about_features_analyzetrends1(inputs)
	return ko_about_features_analyzetrends1(inputs)
});
export { about_features_analyzetrends1 as "about.features.analyzeTrends" }